import { ServiceAccountTab } from '../ServiceAccountsTypes';
import { Icon, Icons, Tabs, Tooltip } from '@silverfort/sf-components';
import { FC, SVGProps, useMemo } from 'react';
import { useServiceAccountContext } from '../contexts/ServiceAccountContext';

export const ServiceAccountTabName: FC<ServiceAccountTab> = ({ name, amount, description }) => (
    <div className="flex justify-content-center items-center gap-1">
        <span className="text-nowrap">{`${name} (${amount.toLocaleString()})`}</span>
        <Tooltip title={description} width={320}>
            <Icon icon={Icons.Info as FC<SVGProps<SVGSVGElement>>} size={12} className="text-inherit" />
        </Tooltip>
    </div>
);

export const ServiceAccountTabs: FC = () => {
    const { tabs, setActiveTab, activeTab } = useServiceAccountContext();

    const formattedTabs = useMemo(
        () => Object.values(tabs).map((tab) => ({ ...tab, name: <ServiceAccountTabName {...tab} /> })),
        [tabs, tabs[activeTab].amount]
    );

    return (
        <Tabs
            tabs={formattedTabs}
            onClick={(tabIndex) => setActiveTab(formattedTabs[tabIndex].type)}
            selectedTab={tabs[activeTab].value}
        />
    );
};
